module.exports = __webpack_public_path__ + "img/fx_zanwushujv@2x.9a754fd0.png";